import { Sub as DropdownSubContent } from "@radix-ui/react-dropdown-menu";

export default DropdownSubContent;
